export const accordionRootRecipe = {
  base: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
};

export const accordionItemRecipe = {
  base: {
    border: "none",
  },
};

export const accordionItemTriggerRecipe = {
  base: {
    bg: "#f7fafc",
    borderRadius: 20,
    padding: 5,
    _expanded: {
      bg: "#e2e8f0",
    },
    _hover: {
      bg: "#e2e8f0",
    },
  },
};

export const accordionItemBodyRecipe = {
  base: {
    my: 2,
  },
};
